import { gql, useQuery } from '@apollo/client';

export const PO_TRANSACTION_QUERY = gql`
  query PoTransaction($id: Int!) {
    poSaleOrder {
      poTransaction(id: $id) {
        id
        poSaleOrderId
        shipperId
        status
        nguoiNhanHang
        ngayGiaoHang
        lyDoKhongPhatDuoc
        ngayDVVCLayHang
        tienCOD
        trongLuongTinhCuocKg
        soKien
        phiShip
        phiHoanTra
        noiDungKhac
        dain
        createdAt
        modifiedAt
        poSaleOrder {
          id
          cd
          orderDate
          deliveryAddress
          receiver
          customer {
            id
            cd
            name
            address1
            phone11
          }
          distributor {
            id
            cd
            name
          }
        }
        shipper {
          id
          cd
          name
        }
        items {
          id
          productId
          unitId
          soLuongGuiGiao
          soLuongGiaoThanhCong
          isFree
          donGia
          thanhTienTruocCK
          chietKhau
          thanhTien
          product {
            id
            cd
            name
            barcode
            otherReference
            salesUnit {
              id
              cd
            }
          }
          unit {
            id
            cd
          }
        }
      }
    }
  }
`;

export interface PoTransactionQueryVariables {
  id: number;
}

export const usePoTransactionQuery = (options?: any) =>
  useQuery(PO_TRANSACTION_QUERY, options);

